import {
  faCircleCheck,
  faAward,
  faGrid2Plus,
  faWavePulse,
  faTicketSimple,
  faCertificate,
  faChartRadar,
} from '@fortawesome/pro-regular-svg-icons';

import { useFeatureFlag } from 'src/common/hooks';
import { useFeatureIsOn } from 'src/common/growthbook';
import { FeatureFlagName } from 'src/common/constants';

import { PublicProfileTab, PublicProfileTabPanelValue, UsePublicProfileTabsProps } from '../public-profile.types';

export const usePublicProfileTabs = ({
  loggedInUserId,
  publicProfileUserId,
}: UsePublicProfileTabsProps): PublicProfileTab[] => {
  const { enabled: isCertificatesEnabled } = useFeatureFlag(FeatureFlagName.CERTIFICATES_PUBLIC_PROFILE);
  const isSkillsMatrixEnabled = useFeatureIsOn('skills-matrix-public-profile');

  const tabs: PublicProfileTab[] = [
    { value: PublicProfileTabPanelValue.COMPLETED_ROOMS, text: 'Completed rooms', icon: faCircleCheck },
    { value: PublicProfileTabPanelValue.BADGES, text: 'Badges', icon: faAward },
    ...(isSkillsMatrixEnabled
      ? [{ value: PublicProfileTabPanelValue.SKILLS_MATRIX, text: 'Skills matrix', icon: faChartRadar }]
      : []),
    { value: PublicProfileTabPanelValue.CREATED_ROOMS, text: 'Created rooms', icon: faGrid2Plus },
    { value: PublicProfileTabPanelValue.YEARLY_ACTIVITY, text: 'Yearly activity', icon: faWavePulse },
    { value: PublicProfileTabPanelValue.TICKETS, text: 'Tickets', icon: faTicketSimple },
  ];

  if (isCertificatesEnabled && loggedInUserId === publicProfileUserId) {
    tabs.splice(1, 0, { value: PublicProfileTabPanelValue.CERTIFICATES, text: 'Certificates', icon: faCertificate });
  }

  return tabs;
};
